/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/namespace */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */

import { Breadcrumb, Button, Card, Input, message, DatePicker, Space, Tooltip, Form } from 'antd';
import { useLoadScript } from '@react-google-maps/api';

import React, { useState, useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {
	ReloadOutlined,
	MinusOutlined,
	FilterOutlined,
	FileExcelOutlined,
	UsergroupAddOutlined,
	UserOutlined,
	SearchOutlined,
} from '@ant-design/icons';
import { CSVLink } from 'react-csv';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import { useLocation, useParams } from 'react-router';
import Highlighter from 'react-highlight-words';
import { getAllBookings, getAllBookingsWithCretaria } from '../../redux/bookingSlice';
import { style } from '../../Styles';
import CustomTableComponents from '../Global/CustomTableComponents';
import DetailsModal from './DetailsModal';
import CustomAvatar from '../Global/CustomAvatar/CustomAvatar';
import { getRandomGoogleMapsKey } from '../../redux/googleMapsKeySlice';
import { formatDateAndTime } from '../../Utils/date-utils';
import ImageComponent from '../Global/ImageComponent/ImageComponent';
import FilteringDrawer from './Filtering/FilteringDrawer';
import { getFullListDrivers } from '../../redux/driverSlice';
import { getAllRiders, getFullListRiders } from '../../redux/riderSlice';
import { formatEnumValue } from '../../Utils/ArrayToObject';
import { getAllCorporates } from '../../redux/corporateSlice';
import ActionButtonWithRefund from './ActionButtonWithRefund';
import RefundBookingModal from './Refund/RefundBookingModal';
import ModalRefundDetails from './Refund/ModalRefundDetails';
import { getSpanStyle } from '../../Utils/style-depending-on-status';
import { bookingStatuses } from '../../Utils/Constants/utils';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import { getAllFleetOperators } from '../../redux/fleetOperatorSlice';

const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';
const libraries = ['core', 'places', 'geocoding', 'routes', 'geometry'];
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(utc);

const Booking = ({ role }) => {
	const [search, setSearch] = useState('');
	const searchTimerRef = useRef(null);
	const [advancedFilters, setAdvancedFilters] = useState({});
	const location = useLocation();
	const [makingApiCall, setMakingApiCall] = useState(false);
	const [csvData, setCsvData] = useState([]);
	const [csvHeaders, setCsvHeaders] = useState([]);
	const [dateRange, setDateRange] = useState([dayjs().startOf('day'), dayjs().endOf('day')]);
	const [showRefundModal, setShowRefundModal] = useState(false);
	const [showRefundDetails, setShowRefundDetails] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [isDataFiltered, setDataFiltered] = useState(false);

	const { googleMaps } = useSelector((state) => state.googleMapsKey);
	const { Settings } = useSelector((state) => state.settings);
	const { corporates } = useSelector((state) => state.corporates);
	const [form] = Form.useForm();

	const openRefundModal = () => {
		setShowRefundModal(true);
	};
	const closeRefundModal = () => {
		setShowRefundModal(false);
	};
	const openRefundDetailsModal = (record) => {
		setSelectedBooking(record);
		setShowRefundDetails(true);
	};
	const closeRefunDetailsdModal = () => {
		setSelectedBooking(null);
		setShowRefundDetails(false);
	};
	const handleExport = () => {
		const params = new URLSearchParams();

		if (advancedFilters.riderId) params.append('riderId', advancedFilters.riderId);
		if (advancedFilters.driverId) params.append('driverId', advancedFilters.driverId);
		if (advancedFilters.statusId) params.append('statusId', advancedFilters.statusId);
		if (advancedFilters.corporateId) params.append('corporateId', advancedFilters.corporateId);
		if (advancedFilters.fleetOperatorId)
			params.append('fleetOperatorId', advancedFilters.fleetOperatorId);
		if (advancedFilters.searchText) params.append('searchText', advancedFilters.searchText);
		const start = dateRange[0].startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
		const end = dateRange[1].endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');

		params.append('start', start);
		params.append('end', end);

		const url = `/api/v1/web/bookings-exportcsv?${params.toString()}`;
		window.open(url, '_blank');
	};

	const [sortedInfo, setSortedInfo] = useState({ columnKey: null, order: null });
	const [isFilteringDrawerOpened, setIsFilteringDrawerOpened] = useState(false);

	const columnSortMap = {
		id: 'id',
		created: 'created',
		numberOfSeats: 'numberOfSeats',
		fleetOperator: 'fleetOperator.name',
		driver: 'driver.name',
		rider: 'rider.name',
		totalFare: 'priceBreakdown.totalFare',
		discount: 'priceBreakdown.discount',
		paidAmount: 'priceBreakdown.paidAmount',
		taxiMode: 'bookingType',
		corporate: 'corporate.name',
		bookingStatus: 'bookingStatus.name',
	};

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		setSortedInfo(sorter.order ? { columnKey: sorter.columnKey, order: sorter.order } : { columnKey: null, order: null });
		setCurrentPage(1);
	};

	const findCorporateName = (id) => {
		const corporate = corporates.corporatesList.find((item) => item.id === id);
		return corporate?.name;
	};
	const currencyRender = () => {
		return <span>{Settings?.settingsData?.currency || '€'}</span>;
	};

	const { isLoaded } = useLoadScript({
		googleMapsApiKey: googleMaps?.googleMapsKey?.key,
		libraries,
	});

	const dispatch = useDispatch();
	const { booking } = useSelector((state) => state.booking);
	const [filter, setfilter] = useState('');
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedBooking, setSelectedBooking] = useState(null);
	const [selectedBookingId, setselectedBookingId] = useState(null);

	const fetchCorporates = () => {
		dispatch(getAllCorporates());
	};
	const fetchFleetOperators = () => {
		dispatch(getAllFleetOperators());
	}

	useEffect(() => {
		fetchFleetOperators();
		fetchCorporates();
	}, [dispatch]);

	const loadDriversAndRiders = () => {
		const promise = Promise.all([
			dispatch(getFullListDrivers()),
			dispatch(getFullListRiders()),
		]);
		promise.then(() => { });
	};
	const openFilteringDrawer = () => {
		loadDriversAndRiders();
		setIsFilteringDrawerOpened(true);
	};

	const closeFilteringDrawer = () => {
		setIsFilteringDrawerOpened(false);
	};

	const openModal = () => {
		setIsModalOpen(true);
	};

	const closeModal = () => {
		setIsModalOpen(false);
	};

	const fetchGoogleMapsKey = () => {
		dispatch(getRandomGoogleMapsKey())
			.then(() => { })
			.catch(() => {
				message.error('Error getting google maps key');
			});
	};

	const [searchText, setSearchText] = useState('');
	const [searchedColumn, setSearchedColumn] = useState('');
	const searchInput = useRef(null);

	const handleSearch = (selectedKeys, confirm, dataIndex) => {
		confirm();
		setSearchText(selectedKeys[0]);
		setSearchedColumn(dataIndex);
	};
	const handleReset = (clearFilters) => {
		clearFilters();
		setSearchText('');
	};

	const getColumnSearchProps = (dataIndex) => ({
		filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
			<div
				style={{
					padding: 8,
				}}
				onKeyDown={(e) => e.stopPropagation()}>
				<Input
					ref={searchInput}
					placeholder={`Search ${dataIndex}`}
					value={selectedKeys[0]}
					onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
					onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
					style={{
						marginBottom: 8,
						display: 'block',
					}}
				/>
				<Space>
					<Button
						type='primary'
						onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
						icon={<SearchOutlined />}
						size='small'
						style={{
							width: 90,
						}}>
						Search
					</Button>
					<Button
						onClick={() => clearFilters && handleReset(clearFilters)}
						size='small'
						style={{
							width: 90,
						}}>
						Reset
					</Button>
					<Button
						type='link'
						size='small'
						onClick={() => {
							confirm({
								closeDropdown: false,
							});
							setSearchText(selectedKeys[0]);
							setSearchedColumn(dataIndex);
						}}>
						Filter
					</Button>
					<Button
						type='link'
						size='small'
						onClick={() => {
							close();
						}}>
						close
					</Button>
				</Space>
			</div>
		),
		filterIcon: (filtered) => (
			<SearchOutlined
				style={{
					color: filtered ? '#1677ff' : undefined,
				}}
			/>
		),
		onFilter: (value, record) =>
			record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
		onFilterDropdownOpenChange: (visible) => {
			if (visible) {
				setTimeout(() => searchInput.current?.select(), 100);
			}
		},
		render: (text) =>
			searchedColumn === dataIndex ? (
				<Highlighter
					highlightStyle={{
						backgroundColor: '#ffc069',
						padding: 0,
					}}
					searchWords={[searchText]}
					autoEscape
					textToHighlight={text ? text.toString() : ''}
				/>
			) : (
				text
			),
	});

	const columns = [
		{
			title: 'ID',
			key: 'id',
			dataIndex: 'id',
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'id' ? sortedInfo.order : null,
			...getColumnSearchProps('id'),
			width: '100px',
		},
		{
			title: 'Date',
			key: 'created',
			render: (record) => {
				return record?.created ? formatDateAndTime(record?.created) : <MinusOutlined />;
			},
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'created' ? sortedInfo.order : null,
			width: '130px',
		},
		{
			title: (
				<Tooltip title='Number of Seats'>
					<span>Number of Seats</span>
				</Tooltip>
			),
			key: 'numberOfSeats',
			dataIndex: 'numberOfSeats',
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'numberOfSeats' ? sortedInfo.order : null,
			width: '100px',
		},
		{
			title: 'Fleet Operator',
			key: 'fleetOperator',
			render: (record) => {
				const fleetOperator = record?.fleetOperator?.name ?? '-';
				return (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<div>
							<span>{`${fleetOperator}`}</span>
						</div>
					</div>
				);
			},
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'fleetOperator' ? sortedInfo.order : null,
			width: '140px',
		},
		{
			title: 'Driver',
			key: 'driver',
			render: (record) => {
				const fullName = `${record?.driver?.name} ${record?.driver?.surname} `;
				return record?.driver ? (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						{record?.driver?.profilePicture ? (
							<ImageComponent size={40} imageId={record?.driver?.profilePicture} />
						) : (
							<CustomAvatar size={40} name={fullName} type='initials' />
						)}
						<div>
							<span>{`${record?.driver?.name} ${record?.driver?.surname} `}</span>
							{!record.driver?.active ? (
								<span
									style={{
										color: 'GrayText',
										fontSize: '12px',
										display: 'block',
										marginLeft: '2px',
									}}>
									(Inactive)
								</span>
							) : null}
						</div>
					</div>
				) : (
					<MinusOutlined />
				);
			},
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'driver' ? sortedInfo.order : null,
			width: '160px',
		},
		{
			title: 'Rider',
			key: 'rider',
			render: (record) => {
				const fullName = role?.includes('SUPER_ADMIN')
					? `${record?.rider?.name} ${record?.rider?.surname}`
					: `${record?.rider?.name}`;
				return record?.rider ? (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						{record?.rider?.profilePicture ? (
							<ImageComponent size={40} imageId={record?.rider?.profilePicture} />
						) : (
							<CustomAvatar size={40} name={fullName} type='initials' />
						)}
						<div>
							<span>{`${fullName} `}</span>
							{!record.rider?.active ? (
								<span
									style={{
										color: 'GrayText',
										fontSize: '12px',
										display: 'block',
										marginLeft: '2px',
									}}>
									(Inactive)
								</span>
							) : null}
						</div>
					</div>
				) : (
					<MinusOutlined />
				);
			},

			sorter: true,
			sortOrder: sortedInfo.columnKey === 'rider' ? sortedInfo.order : null,
			width: '160px',
		},
		{
			title: 'Total Fare',
			key: 'totalFare',
			render: (record) => {
				return (
					<span>
						{currencyRender()}
						{`${record?.priceBreakdown?.totalFare?.toFixed(2)}`}
					</span>
				);
			},
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'totalFare' ? sortedInfo.order : null,
			width: '100px',
		},
		{
			title: 'Discounted Fare',
			key: 'discount',
			render: (record) => {
				return record?.priceBreakdown?.discount ? (
					<span>
						{currencyRender()}
						{`${record?.priceBreakdown?.discount?.toFixed(2)}`}
					</span>
				) : (
					<MinusOutlined />
				);
			},
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'discount' ? sortedInfo.order : null,
			width: '120px',
		},
		{
			title: 'Paid Amount',
			key: 'paidAmount',
			render: (record) => {
				const paidAmount = record?.priceBreakdown?.paidAmount;
				const totalFare = record?.priceBreakdown?.totalFare;
				return (
					<span>
						{currencyRender()}
						{paidAmount !== null && paidAmount !== undefined
							? paidAmount.toFixed(2)
							: totalFare.toFixed(2)}
					</span>
				);
			},

			sorter: true,
			sortOrder: sortedInfo.columnKey === 'paidAmount' ? sortedInfo.order : null,
			width: '100px',
		},
		// {
		// 	title: 'Cancellation Fee',
		// 	key: 'cancellationFee',
		// 	render: (record) => {
		// 		const cancellationFee = record?.priceBreakdown?.cancellationFee;

		// 		return cancellationFee !== null && cancellationFee !== undefined ? (
		// 			<span>
		// 				{currencyRender()}
		// 				{cancellationFee.toFixed(2)}
		// 			</span>
		// 		) : (
		// 			<MinusOutlined />
		// 		);
		// 	},
		// 	defaultSortOrder: 'ascend',
		// 	sorter: (a, b) => a.priceBreakdown?.paidAmount - b.priceBreakdown?.paidAmount,
		// 	width: '150px',
		// },
		{
			title: 'Mode',
			key: 'taxiMode',
			render: (record) => {
				// const taxiMode is to filter record?.taxiModeWithRole and search for the item that have role === 'DRIVER'
				const taxiMode = record?.bookingType;
				return (
					<span style={style.dataContainer}>
						{taxiMode ? (
							taxiMode === 'SHARED' ? (
								<div
									style={{
										...style.tags,
										color: '#008080',
										backgroundColor: '#e0f2f1',
										borderColor: '#4db6ac',
									}}>
									<UsergroupAddOutlined /> {taxiMode && taxiMode}
								</div>
							) : (
								<div
									style={{
										...style.tags,
										color: '#f39c12',
										backgroundColor: '#fff3cd',
										borderColor: '#e08e0b',
									}}>
									<UserOutlined /> {taxiMode && taxiMode}
								</div>
							)
						) : (
							<MinusOutlined />
						)}
					</span>
				);
			},
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'taxiMode' ? sortedInfo.order : null,
			width: '80px',
		},
		// {
		// 	title: 'Vehicle Type',
		// 	key: 'vehicleType',
		// 	render: (record) => {
		// 		return record?.vehicleType && record?.vehicleType?.vehicleType ? (
		// 			<span style={style.tags}>{`${formatEnumValue(
		// 				record?.vehicleType?.vehicleType,
		// 			)} `}</span>
		// 		) : (
		// 			<MinusOutlined />
		// 		);
		// 	},
		// 	defaultSortOrder: 'ascend',

		// 	sorter: (a, b) =>
		// 		a?.vehicleType?.vehicleType?.length - b?.vehicleType?.vehicleType?.length,
		// 	width: '80px',
		// },
		{
			title: 'Corporate',
			key: 'corporate',
			render: (record) => {
				const corporateName = record?.corporate?.name;
				return corporateName ? (
					<span style={{ ...style.tags, whiteSpace: 'nowrap' }}>{corporateName}</span>
				) : (
					<MinusOutlined />
				);
			},
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'corporate' ? sortedInfo.order : null,
			width: '120px',
		},
		{
			title: 'Status',
			key: 'bookingStatus',
			render: (record) => {
				return (
					<span style={style.dataContainer}>
						<div style={getSpanStyle(record?.bookingStatus?.name)}>
							{formatEnumValue(record.bookingStatus?.name)}
						</div>
						{record?.bookingRefundHistories &&
						record?.bookingRefundHistories?.length > 0 ? (
							<span
								style={{
									color: 'GrayText',
									fontSize: '12px',
									marginLeft: '2px',
									marginTop: '5px',
								}}>
								{' '}
								(Refunded)
							</span>
						) : null}
					</span>
				);
			},
			sorter: true,
			sortOrder: sortedInfo.columnKey === 'bookingStatus' ? sortedInfo.order : null,
			width: '80px',
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<ActionButtonWithRefund
					record={record}
					onSeeDetails={(rec) => {
						setselectedBookingId(rec.id);
						openModal();
					}}
					setSelectedBooking={setSelectedBooking}
					onRefund={openRefundModal}
					showRefundDetails={showRefundDetails}
					openRefundDetailsModal={openRefundDetailsModal}
					closeRefunDetailsdModal={closeRefunDetailsdModal}
				/>
			),
			width: '90px',
		},
	];

	const fetchBookings = () => {
		setMakingApiCall(true);

		const start = dateRange[0].startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
		const end = dateRange[1].endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');

		const filterPayload = {
			statusId: advancedFilters.statusId || null,
			driverId: advancedFilters.driverId || null,
			riderId: advancedFilters.riderId || null,
			corporateIds: !advancedFilters.corporateId ? null : [advancedFilters.corporateId],
			fleetOperatorId: advancedFilters.fleetOperatorId || null,
			start,
			end,
		};

		if (search) {
			filterPayload.searchText = search;
		}

		const sortBy = (sortedInfo.columnKey && columnSortMap[sortedInfo.columnKey]) || 'created';
		const sortDirection = sortedInfo.order === 'ascend' ? 'ASC' : 'DESC';

		dispatch(
			getAllBookingsWithCretaria({
				filterData: filterPayload,
				page: currentPage - 1,
				size: pageSize,
				sortBy,
				sortDirection,
			})
		)
			.unwrap()
			.catch(() => { message.error('Error fetching bookings'); })
			.finally(() => { setMakingApiCall(false); });
	};

	useEffect(() => {
		fetchGoogleMapsKey();
	}, [dispatch]);

	useEffect(() => {
		fetchBookings();
	}, [dateRange, currentPage, pageSize, advancedFilters, search, sortedInfo]);

	const data = booking?.bookingList ? Object.values(booking.bookingList) : [];

	const onGridDoubleClick = (record) => {
		setselectedBookingId(record.id);
		setSelectedBooking(record);
		openModal();
	};

	const onDateRangeChange = (value) => {
		setDateRange(value);
		setCurrentPage(1);
		if (value && value[1].diff(value[0], 'day') > 90) {
			message.warning('Large date ranges may take longer to load.');
		}
	};

	const { id } = useParams();

	useEffect(() => {
		if (id) {
			// get booking by id
			const bookingById = data.find((bookingItem) => bookingItem.id === parseInt(id, 10));
			setSelectedBooking(bookingById);
			openModal();
		}
	}, [id]);

	const onSave = (values) => {
		setAdvancedFilters(values);
		setCurrentPage(1);
		closeFilteringDrawer();
	};



	return (
		<>
			<Card
				style={{
					margin: 16,
					maxHeight: '90%',
					height: 'auto',
				}}>
				<div style={style.inlineContent}>
					<div
						style={{
							display: 'flex',
							alignContent: 'center',
							alignItems: 'center',
							float: 'left',
							marginBottom: 8,
						}}>
						<Breadcrumb
							style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
							items={[
								{
									title: 'Bookings',
								},
							]}
						/>
						<Button
							type='default'
							size='small'
							onClick={() => {
								setSearch('');
								setAdvancedFilters({});
								setCurrentPage(1);
							}}
							>
							<ReloadOutlined />
						</Button>
					</div>
					<div
						style={{
							display: 'flex',
							alignContent: 'center',
							alignItems: 'center',
							float: 'center',
							marginBottom: 8,
						}}>
						<RangePicker
							onChange={onDateRangeChange}
							defaultValue={dateRange}
							format={dateFormat}
							style={{ width: '100%' }}
							allowClear={false}
							disabledDate={(current) => current && current > dayjs().endOf('day')}
						/>
					</div>
					<div
						style={{
							...style.inlineContent,
							float: 'right',
							marginBottom: 8,
						}}>
						<Button
							icon={<FileExcelOutlined />}
							onClick={handleExport}
							style={{ marginRight: '0.5em', marginTop: '-9px' }}>
							Export
						</Button>

						<Button
							icon={<FilterOutlined />}
							onClick={openFilteringDrawer}
							style={{ marginRight: '0.5em', marginTop: '-9px' }}>
							Filter
						</Button>
						<Input.Search
							placeholder="Search"
							style={{ margin: '0 8px 8px 0' }}
							allowClear
							loading={makingApiCall}
							onSearch={(val) => {
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								setCurrentPage(1);
								setSearch(val);
							}}
							onChange={(e) => {
								const val = e.target.value;
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								searchTimerRef.current = setTimeout(() => {
									setCurrentPage(1);
									setSearch(val);
								}, 400);
							}}
						/>
					</div>
				</div>
				<CustomTableComponentsPageable
					isMakingApiCall={makingApiCall}
					columns={columns}
					dataArray={data}
					handleDoubleClickRow={(record) => {
						onGridDoubleClick(record);
					}}
					handleSelectedRow={() => { }}
					onTableChange={handleTableChange}
					pagination={{
						current: currentPage,
						pageSize,
						total: booking.total || 0,
						onChange: (page, size) => {
							setCurrentPage(page);
							setPageSize(size);
						},
					}}
				/>
			</Card>

			{isModalOpen && (
				<DetailsModal
					isModalOpen={isModalOpen}
					closeModal={closeModal}
					// booking={selectedBooking}
					isLoaded={isLoaded}
					role={role}
					bookingId={selectedBookingId}
				/>
			)}
			{isFilteringDrawerOpened && (
				<FilteringDrawer
					closeFilteringDrawer={closeFilteringDrawer}
					isFilteringDrawerOpened={isFilteringDrawerOpened}
					resetFilter={() => {
						setSearch('');
						setAdvancedFilters({});
						setCurrentPage(1);
					}}
					role={role}
					form={form}
					onSave={onSave}
				/>
			)}
			<RefundBookingModal
				show={showRefundModal}
				onClose={closeRefundModal}
				booking={selectedBooking}
			/>
			<ModalRefundDetails
				show={showRefundDetails}
				onClose={closeRefunDetailsdModal}
				booking={selectedBooking}
			/>
		</>
	);
};

export default Booking;
